/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getReleaseNotesState } from '../fn/release-notes/get-release-notes-state';
import { GetReleaseNotesState$Params } from '../fn/release-notes/get-release-notes-state';
import { ReleaseNotesStateDto } from '../models/release-notes-state-dto';
import { setReleaseNotesState } from '../fn/release-notes/set-release-notes-state';
import { SetReleaseNotesState$Params } from '../fn/release-notes/set-release-notes-state';

@Injectable({ providedIn: 'root' })
export class GeneratedReleaseNotesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getReleaseNotesState()` */
  static readonly GetReleaseNotesStatePath = '/api/release-notes/state';

  /**
   * Gets which release notes the signed-in user has seen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReleaseNotesState()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReleaseNotesState$Response(params?: GetReleaseNotesState$Params, context?: HttpContext): Observable<StrictHttpResponse<ReleaseNotesStateDto>> {
    return getReleaseNotesState(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets which release notes the signed-in user has seen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReleaseNotesState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReleaseNotesState(params?: GetReleaseNotesState$Params, context?: HttpContext): Observable<ReleaseNotesStateDto> {
    return this.getReleaseNotesState$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReleaseNotesStateDto>): ReleaseNotesStateDto => r.body)
    );
  }

  /** Path part for operation `setReleaseNotesState()` */
  static readonly SetReleaseNotesStatePath = '/api/release-notes/state';

  /**
   * Records the newest release notes the signed-in user has seen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setReleaseNotesState()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setReleaseNotesState$Response(params: SetReleaseNotesState$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setReleaseNotesState(this.http, this.rootUrl, params, context);
  }

  /**
   * Records the newest release notes the signed-in user has seen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setReleaseNotesState$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setReleaseNotesState(params: SetReleaseNotesState$Params, context?: HttpContext): Observable<void> {
    return this.setReleaseNotesState$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
